<template>
  <div class="notice">
    <div class="noticeContent publick">
      <div class="content">
        <div class="Tit">别说早教老师不专业，那是你没找到正确的培训方法！</div>
        <ul>
          <li v-for="(item,index) in info.data" :key="index">
            <div class="fl">
              <b v-if="item.is_read === 2" ></b>
            </div>
            <div class="fr">
              <p v-html="item.content" ></p>
              <div class="time">{{item.create_time}}</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="page publick">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="pageChange"
        :total="info.count">
      </el-pagination>
    </div>
    <layerRight></layerRight>
  </div>
</template>

<script>
  import layerRight from '@/components/layerRight/layerRight'

  export default {
    components: {
      layerRight
    },
    data () {
      return {
        page: 0,
        info: {}
      }
    },
    created () {
      this.$store.state.headindex = 99
      this.getData()
    },
    methods: {
      pageChange (page) {
        this.page = page
        this.getData()
      },
      getData () {
        this.$http.post('/apipx/Notice/systemlist', {
          p: this.page,
          row: 10,
          token: JSON.parse(localStorage.getItem('login')).token
        }).then(res => {
          if (res.code === 0) {
            this.info = res
          }
        })
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .notice {
    .noticeContent {
      margin-top: 70px;
    }

    .content {
      padding: 35px;
      background-color: #fff;
      border-radius: 30px;
      box-shadow: 0px 0px 20px #f5f5f5;
      min-height: 450px;

      .Tit {
        font-size: 26px;
      }

      ul {
        li {
          margin-top: 35px;
          overflow: hidden;

          .fl {
            width: 30px;
            overflow: hidden;

            b {
              display: block;
              width: 5px;
              height: 5px;
              border-radius: 50%;
              background-color: #ff827b;
              margin: 10px 0 0 0;
            }
          }

          .fr {
            width: 1100px;
            line-height: 25px;
            border-bottom: 1px solid #ebebeb;

            .time {
              color: #b3b3b3;
              margin: 10px 0 15px 0;
            }
          }
        }
      }
    }

    .page {
      height: 35px;
      margin: 50px auto;

      .el-pagination {
        width: 500px;
        margin: 0 auto;
      }

      .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
        border-radius: 50%;
        min-width: 33px;
        min-height: 33px;
        line-height: 33px;
        margin: 0 8px;

        &:hover {
          color: #ff8484;
        }
      }

      .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #ff8484;
        color: #FFF;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/notice/notice.vue